export enum VacancyStatus {
    DRAFT = 'DRAFT',
    OPEN = 'OPEN',
    PAUSED = 'PAUSED',
    IN_PROGRESS = 'IN_PROGRESS',
    CLOSED = 'CLOSED',
    CANCELLED = 'CANCELLED'
}

export const VACANCY_STATUS_LABELS: Record<VacancyStatus, string> = {
    [VacancyStatus.DRAFT]: 'Rascunho',
    [VacancyStatus.OPEN]: 'Aberta',
    [VacancyStatus.PAUSED]: 'Pausada',
    [VacancyStatus.IN_PROGRESS]: 'Em andamento',
    [VacancyStatus.CLOSED]: 'Fechada (preenchida)',
    [VacancyStatus.CANCELLED]: 'Cancelada',
};

export const WORK_MODEL_LABELS: Record<string, string> = {
    REMOTE: 'Remoto',
    HYBRID: 'Híbrido',
    ON_SITE: 'Presencial',
};

export const SENIORITY_LABELS: Record<string, string> = {
    INTERN: 'Estagiário',
    JUNIOR: 'Júnior',
    MID_LEVEL: 'Pleno',
    SENIOR: 'Sênior',
    SPECIALIST: 'Especialista',
    LEAD: 'Líder',
};

export enum RecruitmentStep {
    RESUME_SCREENING = 'RESUME_SCREENING',
    BEHAVIORAL_EVALUATION = 'BEHAVIORAL_EVALUATION',
    TECHNICAL_TEST = 'TECHNICAL_TEST',
    RESUME_AND_TEST_EVALUATION = 'RESUME_AND_TEST_EVALUATION',
    TECHNICAL_INTERVIEW = 'TECHNICAL_INTERVIEW',
    NEGOTIATION = 'NEGOTIATION',
    CLOSED = 'CLOSED',
    REJECTED = 'REJECTED'
}

export interface JobApplication {
    id: number;
    vacancy_id: number;
    candidate_id: number;
    candidate_name: string;
    candidate_email: string;
    resume_url: string;
    linkedin_url?: string;
    phone?: string;
    current_step: RecruitmentStep;
    current_step_label: string;
    status: string;
    feedback?: string;
    technical_feedback?: string;
    salary_expectation?: number;
    availability_date?: string;
    created_at: string;
    updated_at: string;
    other_applications_count: number;
    step_history: {
        step: string;
        date: string;
        feedback?: string;
    }[];
}

export interface JobVacancy {
    id: number;
    project_position_id: number;
    position_id: number;
    role: string;
    project_id?: number;
    project_name?: string;
    contract_type: string;
    base_salary: number;
    status: VacancyStatus;
    status_label: string;
    description?: string;
    requirements?: string;
    benefits?: string;
    location?: string;
    work_model?: string;
    seniority?: string;
    is_public: boolean;
    has_new_candidates: boolean;
    has_technical_updates: boolean;
    created_at: string;
    updated_at: string;
    applications: JobApplication[];
    total_applications: number;
    applications_by_step: {
        [key in RecruitmentStep]: number;
    };
}

export interface AvailablePosition {
    id: number;
    role: string;
    contract_type: string;
    base_salary: number;
    project_id: number;
    project_name: string;
}

export interface CreateVacancyData {
    project_position_id: number;
    contract_type: string;
    base_salary: number;
    description?: string;
    requirements?: string;
    benefits?: string;
    location?: string;
    work_model?: string;
    seniority?: string;
    is_public: boolean;
    status: VacancyStatus;
}

export interface UpdateVacancyData {
    contract_type?: string;
    base_salary?: number;
    description?: string;
    requirements?: string;
    benefits?: string;
    location?: string;
    work_model?: string;
    seniority?: string;
    is_public?: boolean;
}

export interface CreateApplicationData {
    candidate_name: string;
    candidate_email: string;
    resume: File;
    linkedin_url?: string;
    phone?: string;
    salary_expectation?: number;
    availability_date?: string;
}

export interface UpdateApplicationStepData {
    step: RecruitmentStep;
    feedback?: string;
    technical_feedback?: string;
}

export interface VacancyStats {
    total_vacancies: number;
    open_vacancies: number;
    avg_time_to_fill: number;
    applications_by_step: {
        [key in RecruitmentStep]: number;
    };
    conversion_rates: {
        step: string;
        conversion_rate: number;
    }[];
}

export interface Candidate {
    id: number;
    name: string;
    email: string;
    linkedin_url?: string;
    phone?: string;
    resume_url?: string;
    created_at: string;
    updated_at: string;
} 